import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider, theme } from 'antd';
import zhTW from 'antd/locale/zh_TW';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        locale={zhTW}
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: {
            colorPrimary: '#dd7900',
            colorLink: '#dd7900',
            borderRadius: 8,
            fontFamily: "'Noto Sans TC', system-ui, -apple-system, sans-serif",
            colorBgLayout: '#f5f6f8',
          },
          components: {
            Layout: { siderBg: '#ffffff', headerBg: '#ffffff', bodyBg: '#f5f6f8' },
            Menu: { itemSelectedBg: '#fff3e0', itemSelectedColor: '#dd7900' },
          },
        }}
      >
        <App />
      </ConfigProvider>
    </QueryClientProvider>
  </StrictMode>,
);
